import { AstraParagraph, astraTwMerge } from '~/astra'

import { PreviewCellView } from '../Apply/types'

type TagProps = {
    label: string
    color: string
}

const PreviewTag = ({ label, color }: TagProps) => (
    <div
        style={{ background: color, borderColor: `color-mix(in srgb, ${color} 90%, black)` }}
        className="flex min-w-[20px] flex-1 items-center justify-center overflow-hidden rounded text-center"
    >
        <AstraParagraph className="hero-label flex min-w-0 flex-1 items-center justify-center overflow-hidden">
            <span className="full">{label}</span>
            <span className="initial" aria-hidden="true">
                {label[0]}
            </span>
        </AstraParagraph>
    </div>
)

export const PreviewCell = ({ cell }: { cell: PreviewCellView }) => {
    if (cell.unavailable) {
        return (
            <div className="flex h-full items-center justify-center bg-[#F0F0F3]">
                <div className="w-1/4 rounded-md border border-strong" />
            </div>
        )
    }

    return (
        <div className="grid h-full grid-cols-1 grid-rows-2 gap-y-1 p-1">
            <div className="flex items-stretch gap-x-0.5">
                {cell.statuses.map(status => (
                    <PreviewTag key={status.code} {...status} />
                ))}
            </div>
            <div className={astraTwMerge('flex items-stretch gap-x-0.5', cell.locations.length > 3 ? '-space-x-5' : '')}>
                {cell.locations.map(location => (
                    <PreviewTag key={location.roomCode} label={location.roomCode} color={location.hasConflict ? '#fca5a5' : '#E6E9E8'} />
                ))}
            </div>
        </div>
    )
}
